import React from 'react';
import {
    SearchInput,
    TextInput,
    SelectInput,
    BooleanInput,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import GetAppIcon from '@mui/icons-material/GetApp';

import Datagrid from '../common/Datagrid';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import { TextField, EmailField, BooleanField, ReferenceField } from 'react-admin';
import List, { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';

import { API_URL } from '../../services/settings';

const customerOptionText = choice => {
    return choice.name ? choice.name : '';
};

const ContactListActions = (props) => (
    <ListActions {...props}>
        <IconButton icon={<GetAppIcon />} component="a" href={`${API_URL}/contacts/export.xls`}>Export</IconButton>
    </ListActions>
);

const contactFilters = [
    <SearchInput source="q" alwaysOn />,
    <ReferenceInput label="Customer" source="customer_id" reference="customers" alwaysOn>
        <AutocompleteInput optionText={customerOptionText} />
    </ReferenceInput>,
    <TextInput label="Company" source="company" />,
    <SelectInput
        label="Contact Type"
        source="contact_type"
        choices={[
            { id: 'general', name: 'General' },
            { id: 'lead', name: 'Lead' },
            { id: 'prospect', name: 'Prospect' },
            { id: 'customer', name: 'Customer' },
            { id: 'churned', name: 'Churned' },
            { id: 'partner', name: 'Partner' },
        ]}
    />,
    <SelectInput
        label="Status"
        source="status"
        choices={[
            { id: 'active', name: 'Active' },
            { id: 'inactive', name: 'Inactive' },
        ]}
    />,
    <BooleanInput label="Marketing Consent" source="marketing_consent" />,
];

const ContactList = props => (
    <List
        {...props}
        filters={contactFilters}
        actions={<ContactListActions />}
        exporter={false}
    >
        <Datagrid>
            <ResourceLinkField label="Name" resource="contacts" sortBy="full_name">
                <TextField source="full_name" />
            </ResourceLinkField>
            <ReferenceField label="Customer" source="customer_id" reference="customers" allowEmpty linkType="show">
                <TextField source="name" />
            </ReferenceField>
            <EmailField source="email" />
            <TextField source="phone" label="Phone" />
            <TextField source="company" />
            <TextField source="job_title" label="Job Title" />
            <TextField source="contact_type" label="Type" />
            <TextField source="status" />
            <BooleanField source="marketing_consent" label="Marketing" />
            <RecordSplitButton />
        </Datagrid>
    </List>
);

export default ContactList;